import { render } from "./Main.vue?vue&type=template&id=04f9a22f"
const script = {}
script.render = render

export default script